<div fxLayout="row" class="flex-lt-md-col">

    <div class="list-container main-container" fxFlex="100%">
        <div class="settings-wrapper">

            @if (experienceLevel !== experienceLevelType.BEGINNER) {
                <div class="top-actions">
                    <button spinning (click)="onReloadAccountData()" mat-button>
                        <mat-icon class="spinning" matTooltip="{{'account.forceUpdate' | transloco}}">autorenew</mat-icon>
                        {{ 'account.refreshAccount' | transloco }}
                    </button>
                    <button (click)="onForceLogout()" mat-button>
                        <mat-icon matTooltip="{{'account.forceResetLogout' | transloco}}">exit_to_app</mat-icon>
                        {{ 'account.forceReset' | transloco }}
                    </button>
                </div>
            }


            <div class="top-utils d-flex-center">
                <app-local-diag [setLargeMode]="true"></app-local-diag>
                <app-theme-selector></app-theme-selector>
                <app-video-link videoLink="settings"></app-video-link>
            </div>

            <ng-template #generalContent>
                <form [formGroup]="formGroupSettings" (ngSubmit)="onSubmit(formGroup.value)" class="form" style="position: relative;">
                        <div class="settings-grid">
                        @if (isFullFeatures || (navGlobal$ | async) == '1') {

                            <div class="settings-card">
                                <div class="section-header">
                                    <mat-icon>settings_suggest</mat-icon>
                                    <span class="section-title">{{ 'general.globalVisibility' | transloco }}</span>
                                </div>
                                <div class="checkbox-group">
                                    <mat-checkbox (change)="onToggleSettings('showExperienceLevel')"
                                                  formControlName="showExperienceLevel">{{ 'general.experienceLevel2' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('largeLogo')"
                                                  formControlName="largeLogo">{{ 'general.largeLogo' | transloco }}
                                    </mat-checkbox>
                                    @if ((signStudioHelp$ | async) == '1') {
                                        <mat-checkbox (change)="onToggleSettings('showHelpEnabled')"
                                                      formControlName="showHelpEnabled">
                                            {{ 'general.showHelpTips2' | transloco }}
                                        </mat-checkbox>
                                        @if (formGroupSettings.get('showHelpEnabled')?.value) {
                                            <button type="button" mat-button class="sub-action-btn"
                                                    (click)="resetBlinking($event)"
                                                    matTooltip="clear which help videos have been watched">
                                                <mat-icon>replay</mat-icon>
                                                <span>reset watched videos</span>
                                            </button>
                                        }
                                    }
                                    @if (isFullFeatures && experienceLevel !== experienceLevelType.BEGINNER) {
                                        <mat-checkbox (change)="onToggleSettings('saveFullFeature')"
                                                      formControlName="saveFullFeature">dev features
                                        </mat-checkbox>
                                    }
                                    @if (isDev) {
                                        <mat-checkbox (change)="onToggleSettings('useDevServerPort')"
                                                      formControlName="useDevServerPort">use dev server port 9443
                                        </mat-checkbox>
                                    }
                                </div>
                            </div>

                            @if ((isFullFeatures || (navModule$ | async) == '1') && experienceLevel !== experienceLevelType.BEGINNER) {
                                    <div class="settings-card">
                                        <div class="section-header">
                                            <mat-icon>extension</mat-icon>
                                            <span class="section-title">{{ 'general.modulesVisibility' | transloco }}</span>
                                        </div>
                                        <div class="checkbox-group checkbox-group-grid">
                                            <mat-checkbox (change)="onToggleSettings('paintEnabled')"
                                                          formControlName="paintEnabled">{{ 'general.painter' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('catalogEnabled')"
                                                          formControlName="catalogEnabled">{{ 'general.catalogEnabled' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('scheduledEnabled')" formControlName="scheduledEnabled">{{ 'general.scheduler' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('eventsEnabled')"
                                                          formControlName="eventsEnabled">{{ 'general.eventsEnabled' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('fasterqEnabled')"
                                                          formControlName="fasterqEnabled">{{ 'general.fasterqEnabled' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('dashboardEnabled')" formControlName="dashboardEnabled">{{ 'general.dashboard' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('iotEnabled')" formControlName="iotEnabled">{{ 'general.iot' | transloco }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                            }

                            @if (experienceLevel !== experienceLevelType.BEGINNER) {
                                <div class="settings-card">
                                    <div class="section-header">
                                        <mat-icon>settings_suggest</mat-icon>
                                        <span class="section-title">{{ 'general.globalSettings' | transloco }}</span>
                                    </div>
                                    <div class="checkbox-group">
                                        <mat-checkbox (change)="onTogglePreference('newsLetter')"
                                                      formControlName="newsLetter">{{ 'general.receiveNewsLetter' | transloco }}
                                        </mat-checkbox>
                                        <mat-checkbox (change)="onTogglePreference('autoCheckForUpdates')"
                                                      formControlName="autoCheckForUpdates">{{ 'general.autoCheckForUpdates' | transloco }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                            }
                        }

                        @if ((isFullFeatures || (navScene$ | async) == '1') && experienceLevel !== experienceLevelType.BEGINNER) {
                            <div class="settings-card">
                                <div class="section-header">
                                    <mat-icon>control_camera</mat-icon>
                                    <span class="section-title">{{ 'general.sceneControl' | transloco }}</span>
                                </div>
                                <div class="checkbox-group checkbox-group-grid">
                                    <mat-checkbox (change)="onToggleSettings('saveSceneManual')"
                                                  formControlName="saveSceneManual">{{ 'general.saveSceneManual' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('saveSceneTimer')"
                                                  formControlName="saveSceneTimer">{{ 'general.saveSceneTimer' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('showDirections')"
                                                  formControlName="showDirections">{{ 'general.useAutoAlignDragScene' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('stickersAsEmbedded')"
                                                  formControlName="stickersAsEmbedded">{{ 'general.stickersAsShortcuts' | transloco }}
                                    </mat-checkbox>
                                </div>
                                <div class="slider-row">
                                    <div class="slider-container">
                                        <span class="slider-label">{{ 'general.sceneFocusOpacity' | transloco }}</span>
                                        <mat-slider discrete disableRipple color="accent"
                                                    min="1" max="100"
                                                    class="setting-slider">
                                            <input matSliderThumb formControlName="sceneOpacity" (change)="onChangeOpacity($event.target)"/>
                                        </mat-slider>
                                    </div>
                                    <div class="slider-container">
                                        <span class="slider-label">{{ 'general.sceneGuidelinesOpacity' | transloco }}</span>
                                        <mat-slider discrete disableRipple color="accent"
                                                    min="1" max="100"
                                                    class="setting-slider">
                                            <input matSliderThumb formControlName="sceneGuidelinesOpacityLevel" (change)="onChangeSceneGuidelinesOpacity($event.target)"/>
                                        </mat-slider>
                                    </div>
                                </div>
                            </div>
                        }

                            @if (experienceLevel !== experienceLevelType.BEGINNER) {
                                <div class="settings-card">
                                    <div class="section-header">
                                        <mat-icon>tv</mat-icon>
                                        <span class="section-title">{{ 'general.players' | transloco }} ( SignPlayer PWA )</span>
                                    </div>
                                    <div class="checkbox-group">
                                        <mat-checkbox (change)="onToggleSettings('restartPlayer')"
                                                      formControlName="restartPlayer">{{ 'general.restartPlayer4' | transloco }}
                                        </mat-checkbox>
                                        <mat-checkbox (change)="onToggleSettings('restartPlayerOnSceneAssignment')"
                                                      formControlName="restartPlayerOnSceneAssignment">{{ 'general.restartPlayerOnSceneAssignment2' | transloco }}
                                        </mat-checkbox>
                                    </div>
                                    <div class="slider-row">
                                        <div class="slider-container">
                                            <span class="slider-label">{{ 'general.snapshotScale' | transloco }}</span>
                                            <mat-slider discrete disableRipple color="accent"
                                                        min="0.1" max="1" step="0.1"
                                                        class="setting-slider">
                                                <input matSliderThumb formControlName="snapScale" (change)="onChangeSnapScale($event.target)"/>
                                            </mat-slider>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                </form>
            </ng-template>

            @if (experienceLevel === experienceLevelType.BEGINNER) {
                <div class="beginner-content">
                    <ng-container *ngTemplateOutlet="generalContent"></ng-container>
                </div>
            } @else {
                <mat-tab-group [selectedIndex]="activeTabIndex" class="settings-tabs">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon style="margin-right: 8px">settings</mat-icon>
                            General
                        </ng-template>
                        <ng-container *ngTemplateOutlet="generalContent"></ng-container>
                    </mat-tab>
                    <!-- TODO: AI settings tab hidden for now. Bring it back (change @if(false) to @if(true)
                         or a real gate) when working on the AI code. -->
                    @if (false) {
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px; vertical-align: middle;">
                                    <defs>
                                        <linearGradient id="ai-tab-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" style="stop-color:#4A90E2;stop-opacity:1" />
                                            <stop offset="100%" style="stop-color:#357ABD;stop-opacity:1" />
                                        </linearGradient>
                                    </defs>
                                    <path d="M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z" fill="url(#ai-tab-gradient)" stroke="#2C5AA0" stroke-width="1"/>
                                    <text x="12" y="16" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" fill="white">AI</text>
                                </svg>
                                AI
                            </ng-template>
                            <app-ai-settings
                                [aiSettings]="aiSettings"
                                (aiSettingsChange)="onAiSettingsChange($event)">
                            </app-ai-settings>
                        </mat-tab>
                    }
                </mat-tab-group>
            }

        </div>
    </div>
</div>


<!--<p class="actions">-->
<!--    <button mat-raised-button color="accent" routerLink="/overview">-->
<!--        <mat-icon>keyboard_arrow_left</mat-icon>-->
<!--        back</button>-->
<!--    <button *ngIf="!enterpriseMode" mat-raised-button color="warn" (click)="openSearchFormDialog()">-->
<!--        <mat-icon>cloud_upload</mat-icon>-->
<!--        enterprise upgrade-->
<!--    </button>-->
<!--    <button *ngIf="enterpriseMode" mat-raised-button color="primary" (click)="createUser()">-->
<!--        <mat-icon>speaker_notes</mat-icon>-->
<!--        enterprise report-->
<!--    </button>-->
<!--    <button *ngIf="enterpriseMode" mat-raised-button color="primary" (click)="deleteUser()">-->
<!--        <mat-icon>report</mat-icon>-->
<!--        enterprise termination-->
<!--    </button>-->
<!--</p>-->


<!-- test code for Alon -->
<!--                    <input type="button" value="callback" onClick="my1('value1')" />-->
<!--                    <script type="text/javascript">-->
<!--                        function testEcho(v2) {-->
<!--                            alert(v2);-->
<!--                            return "ggg";-->
<!--                        }-->
<!--                        function my1(v2) {-->
<!--                            Android.fromJS("123");-->
<!--                        }-->
<!--                    </script>-->
<!--                    <form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)" class="form">-->


<!--                <div class="form-element">-->
<!--                    <button mat-raised-button color="primary" (submit)="onSubmit($event)" type="submit" class="button" [disabled]="!formGroup.valid">Save user settings</button>-->
<!--                </div>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.email' | transloco}}" formControlName="email">-->
<!--                            <mat-error *ngIf="!formGroup.controls['email'].valid && formGroup.controls['email'].touched">-->
<!--                                {{ getErrorEmail() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input (keyup)="updateName($event)" matInput placeholder="{{'placeholder.accountName' | transloco}}" formControlName="name">-->
<!--                            <mat-error *ngIf="!name.valid && name.touched">-->
<!--                                {{ titleAlert }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <textarea matInput placeholder="{{'placeholder.accountDescription' | transloco}}" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="5" formControlName="description"></textarea>-->
<!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
<!--                                must be 5 to 50 char-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.password' | transloco}}" type="password" formControlName="password">-->
<!--                            <mat-hint>8 characters, uppercase and number</mat-hint>-->
<!--                            <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">-->
<!--                                {{ getErrorPassword() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.datePass' | transloco}}" [matDatepicker]="picker2" formControlName="createTimeEnd">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--                            &lt;!&ndash;                    <mat-datepicker [touchUi]="touchUi" #picker2></mat-datepicker>&ndash;&gt;-->
<!--                            <mat-datepicker  #picker2></mat-datepicker>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <mat-label>-->
<!--                                {{'general.screenNotification' | transloco}}-->
<!--                            </mat-label>-->
<!--                            <mat-select>-->
<!--                                <mat-option *ngFor="let item of screensState" [value]="item.value">-->
<!--                                    {{item.viewValue}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <div class="form-element">-->
<!--                            <mat-checkbox formControlName="validate" value="1">{{'general.requirePassChange' | transloco}}</mat-checkbox>-->
<!--                        </div>-->
<!--                        <mat-divider></mat-divider>-->
<!--                        <div class="pull-right" style="position: relative; top: -15px; padding: 30px">-->
<!--                            <span style="margin-right: 30px" class="pull-right">{{'general.youreMoji2' | transloco}}</span>-->
<!--                            <br/>-->
<!--                            <canvas width="140" height="140" [attr.data-jdenticon-value]="this.user.name"></canvas>-->
<!--                        </div>-->

<!--                        <div fxLayout="row" fxLayout.xs="column" class="form-element">-->
<!--                            <div fxFlex="120px" fxFlex.xs>-->
<!--                                <img class="avatar" [src]="avatarSrc || model.avatarURL">-->
<!--                            </div>-->
<!--                            <div fxFlex="24px" fxFlex.xs="10px"></div>-->
<!--                            <div class="actions" fxFlex>-->
<!--                                <input #avatarInput class="hidden" type="file" accept="image/png, image/jpeg" (change)="selectAvatar($event.target.files)">-->
<!--                                <button mat-raised-button color="primary" (click)="avatarInput.click()">{{'general.select' | transloco}}</button>-->
<!--                                <button mat-raised-button color="accent" (click)="updateAvatar()" [disabled]="!avatarFile || avatarInvalid || uploaded"-->
<!--                                        [matTooltip]="uploaded ? ('general.avatarUpdated' | transloco) : avatarFile ? ('general.avatarClick' | transloco) : ('general.noFile' | transloco)"-->
<!--                                        matTooltipPosition="right">-->
<!--                                    {{uploaded ? 'Updated' : 'Update'}}-->
<!--                                </button>-->
<!--                                <div class="error-wrapper">-->
<!--                                    <mat-error>-->
<!--                                        <ng-template [ngIf]="avatarTooSmall">-->
<!--                                            {{'general.tooLarge' | transloco}}-->
<!--                                        </ng-template>-->
<!--                                        <ng-template [ngIf]="avatarTooLarge">-->
<!--                                            {{'general.tooSmall' | transloco}}-->
<!--                                        </ng-template>-->
<!--                                    </mat-error>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                <div class="form-element">-->
<!--                    <button mat-raised-button color="primary" (submit)="onSubmit($event)" type="submit" class="button" [disabled]="!formGroup.valid">Save user settings</button>-->
<!--                </div>-->

<!--                <div class="container" *ngIf="!post; else forminfo" novalidate>-->
<!--                    <form [formGroup]="formGroup" class="form">-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <input matInput placeholder="{{'placeholder.email' | transloco}}" formControlName="email">-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!formGroup.controls['email'].valid && formGroup.controls['email'].touched">-->
<!--                                {{ getErrorEmail() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <input (keyup)="updateName($event)" matInput placeholder="{{'placeholder.accountName' | transloco}}" formControlName="name">-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!name.valid && name.touched">-->
<!--                                {{ titleAlert }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <textarea matInput placeholder="{{'placeholder.accountDescription' | transloco}}" [matTextareaAutosize]="true" [matAutosizeMinRows]="2" [matAutosizeMaxRows]="5" formControlName="description"></textarea>-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
<!--                                must be 5 to 50 char-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.password' | transloco}}" type="password" formControlName="password">-->
<!--                            <mat-hint>8 characters, uppercase and number</mat-hint>-->
<!--                            <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">-->
<!--                                {{ getErrorPassword() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.datePass' | transloco}}" [matDatepicker]="picker2" formControlName="createTimeEnd">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--                            &lt;!&ndash;                    <mat-datepicker [touchUi]="touchUi" #picker2></mat-datepicker>&ndash;&gt;-->
<!--                            <mat-datepicker #picker2></mat-datepicker>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <mat-label>-->
<!--                                {{'general.screenNotification' | transloco}}-->
<!--                            </mat-label>-->
<!--                            <mat-select>-->
<!--                                <mat-option *ngFor="let item of screensState" [value]="item.value">-->
<!--                                    {{item['viewValue']}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <div class="form-element">-->
<!--                            <mat-checkbox formControlName="validate" value="1">{{'general.requirePassChange' | transloco}}</mat-checkbox>-->
<!--                        </div>-->
<!--                        <mat-divider></mat-divider>-->
<!--                    </form>-->
<!--                </div>-->
